import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage, { ProjectDetail } from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import ClientsPage from './pages/ClientsPage';
import ScrollRestoration from './ScrollRestoration';
// import AllVideos from './components/AllVideos';

function App() {
  return (
    <Router>
      <ScrollRestoration />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            {/* <Route path="/allvideos" element={<AllVideos />} /> */}

            {/* <Route path="/videos" element={<AllVideos />} />
  <Route path="/videos/:id" element={<AllVideos />} /> */}

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
